import React, { useState, useEffect, useContext, createContext } from "react";
import { IoIosArrowUp } from "react-icons/io";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { FaPauseCircle } from "react-icons/fa";
import { LiaPlayCircleSolid } from "react-icons/lia";
import { BsFillExclamationTriangleFill } from "react-icons/bs";
import Modal from "react-bootstrap/Modal";
import { ImCheckmark } from "react-icons/im";
import Button from "react-bootstrap/Button";
import Stopwatch from "./Stopwatch";
import * as api from "../../api/api";
import { MyContext } from "./FormsView";
import Loading from "../Loading";
import RenderField from "./RenderField";
import RenderSection from "./RenderSection";
import exampleSections from "./exampleSections.json";
import { Form } from "react-bootstrap";
import YesNoModal from "../Modal/YesNoModal";
import { FaPlus } from "react-icons/fa6";
import { useLanguage } from "../../Components/Localization/LanguageContext";
import strings from "../../Components/Localization/strings";
const formatTime = (date) => {
  let newDate = new Date(date);
  let hours = newDate.getHours().toString().padStart(2, "0");
  let minutes = newDate.getMinutes().toString().padStart(2, "0");
  let seconds = newDate.getSeconds().toString().padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
};
const getDate = (date) => {
  let newDate = new Date(date);
  const dd = newDate.getDate();
  const mm = newDate.getMonth() + 1; // Months are zero-indexed
  const yyyy = newDate.getFullYear();

  return `${dd}/${mm}/${yyyy}`;
};

function hasDetails(detailsArray) {
  let hasDetails = false;
  if (detailsArray) {
    detailsArray.forEach((element) => {
      if (element.value) {
        hasDetails = true;
      }
    });
  }

  return hasDetails;
}
function determineFormStatus(isRunning, openRow) {
  if (!isRunning) {
    if (openRow) {
      return "opened-form";
    } else {
      return "ended-form";
    }
  } else {
    return "running-form";
  }
}
export const FormRowContext = createContext(false);
function FormRowData({
  process,
  handleEndTime,
  isRunning,
  swapCurrentRunning,
  pauseFunc,
  resumeFunc,
  handleFetchProcesses,
  isAdmin,
  isEditing,
  sendParentElapsedTime,
  isRestricted,
  processDataCache,
  setProcessDataCache,
  showSuccessMessage,
  expandedProcess,
  setRunningCallProcessDetails,
  ongoingCallBool,
}) {
  //   stop watch stuff
  const { language } = useLanguage();
  const pageTitle = "FormRowData";

  const [startTime, setStartTime] = useState();
  const [validated, setValidated] = useState(false);
  const [processForm, setProcessForm] = useState(process.form);
  const [processDetails, setProcessDetails] = useState(
    process.allProcessDetails
  );
  const [parentSelectionValues, setParentSelectionValues] = useState({});
  const [processTimesState, setProcessTimesState] = useState(
    process.allProcessTimes.map((processTime) => ({
      ...processTime,
      startDate: processTime.startTime ? getDate(processTime.startTime) : "",
      startTime: processTime.startTime ? formatTime(processTime.startTime) : "",
      endDate: processTime.endTime ? getDate(processTime.endTime) : "",
      endTime: processTime.endTime ? formatTime(processTime.endTime) : "",
    }))
  );
  const [isLoading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [elapsedTime, setElapsedTime] = useState();
  const [oldElapsedTime, setOldElapsedTime] = useState(0);
  const [timerOn, setTimerOn] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [formOptions, setFormOptions] = useState([]);
  const handleDeleteProcess = (id) => {
    setLoading(true);
    api
      .deleteProcessById(id)
      .then(() => {
        console.log("deleted lob with id: " + id);
        setLoading(false);
      })
      .then(() => {
        handleFetchProcesses();
      });
  };

  const handleDeleteProcessTime = () => {
    api.deleteProcessTime(deleteProcessTimeModal.id).then(() => {
      setProcessTimesState(
        processTimesState.filter(
          (processTime) =>
            processTime.processTimeId !== deleteProcessTimeModal.id
        )
      );
    });
  };

  const handleChangeProcessTime = (event, id, startOrEnd, dateOrTime) => {
    let value = event.target.value;
    let targetTimeArray = processTimesState.filter(
      (time) => time.processTimeId === id
    );
    let targetTime = targetTimeArray[0];
    console.log("id id ", id);
    console.log("target time: ", targetTime);
    if (dateOrTime === "time") {
      // let editedTime = editTime(value, targetTime.startTime);
      if (startOrEnd === "start") {
        let editedTime = event.target.value;
        let newArr = processTimesState.map((time) =>
          time.processTimeId === id ? { ...time, startTime: editedTime } : time
        );
        setProcessTimesState(newArr);
      } else if (startOrEnd === "end") {
        let editedTime = event.target.value;
        let newArr = processTimesState.map((time) =>
          time.processTimeId === id ? { ...time, endTime: editedTime } : time
        );
        setProcessTimesState(newArr);
      }
    } else if (dateOrTime === "date") {
      if (startOrEnd === "start") {
        let editedTime = event.target.value;
        let newArr = processTimesState.map((time) =>
          time.processTimeId === id ? { ...time, startDate: editedTime } : time
        );
        setProcessTimesState(newArr);
      } else if (startOrEnd === "end") {
        let editedTime = event.target.value;
        let newArr = processTimesState.map((time) =>
          time.processTimeId === id ? { ...time, endDate: editedTime } : time
        );
        setProcessTimesState(newArr);
      }
    }
    console.log(event.target.value);
  };
  const [exampleSectionsState, setexampleSectionsState] = useState([]);
  // const handleEndTime = useContext(MyContext);
  const handleCalculateDurations = () => {
    console.log("in handle");
    if (process.allProcessTimes) {
      console.log("in handle if cond");
      let sumDurations = 0;
      for (let i = 0; i < process.allProcessTimes.length; i++) {
        if (process.allProcessTimes[i].duration) {
          sumDurations = sumDurations + process.allProcessTimes[i].duration;
        }
      }
      console.log("sumDurations: ", sumDurations);
      let newDuration = sumDurations * 1000;
      setElapsedTime(newDuration);

      setStartTime(newDuration);
    } else {
      setStartTime(Date.now());
    }
  };
  useEffect(() => {
    if (isRunning) {
      setTimerOn(true);
      setIsPaused(false);
      if (processDataCache[process.processId]) {
        const { processDetailsCache, parentSelectionValuesCache } =
          processDataCache[process.processId];
        console.log("found old data while running", processDataCache);
        setProcessDetails((prevState) => processDetailsCache);
        // setParentSelectionValues((prevState) => parentSelectionValuesCache);
      }
    } else {
      setIsPaused(true);
      if (process.isFinalized) {
        console.log(
          "process is saved so will display process details",
          process.allProcessDetails
        );
        setProcessDetails(process.allProcessDetails);
      } else {
        if (processDataCache[process.processId]) {
          const { processDetailsCache, parentSelectionValuesCache } =
            processDataCache[process.processId];
          console.log("found old data", processDataCache);
          // setParentSelectionValues(parentSelectionValuesCache);
          setProcessDetails((prevState) => processDetailsCache);
        }
      }
    }
    //sum durations before
    handleCalculateDurations();
    console.log("process data is : ", process);
  }, []);
  useEffect(() => {
    console.log("setting process details to", processDetails);
    try {
      // notify on a level upper that the process details have been changed
      setRunningCallProcessDetails((prevState) => {
        return processDetails;
      });
      console.log("Running call process details is: ", processDetails);
    } catch (e) {
      console.log("couldn't set process details to parent");
    }
  }, [processDetails]);

  function getProcessDetailValue(fieldId) {
    processDetails.forEach((field) => {
      if (field.sectionFieldId === fieldId) {
        return field.value;
      }
    });
    return "";
  }
  function formatTimeForRequest(date, time) {
    console.log("date to be split ", date);
    console.log("time in edit", time);
    const [day, month, year] = date.split("/");
    const [hh, mm, ss] = time.split(":");
    let newDate =
      year + "-" + month + "-" + day + " " + hh + ":" + mm + ":" + ss;
    console.log(date);
    return transformDateToRequestFormat(new Date(newDate));
  }
  function handleSubmitDateTimeEdit(id, event, type) {
    console.log("in onblur func ", event.target.value);
    //implement validation here / or correction

    //send api request if passed validation
    let newStartTime = "";
    let newEndTime = "";
    let targetTimeArray = processTimesState.filter(
      (time) => time.processTimeId === id
    );
    let targetTime = targetTimeArray[0];

    newStartTime = formatTimeForRequest(
      targetTime.startDate,
      targetTime.startTime
    );
    newEndTime = formatTimeForRequest(targetTime.endDate, targetTime.endTime);
    // comparing edited dates in the front end before sending
    let processTimeErr = document.getElementById("processTime-" + id);
    let startDateObj = new Date(newStartTime);
    let endDateObj = new Date(newEndTime);
    let currentDateObj = new Date();
    if (endDateObj < startDateObj) {
      processTimeErr.textContent =
        "End date and Time can not be before the start date time";
      return;
    } else if (startDateObj > currentDateObj) {
      processTimeErr.textContent =
        "Start date and Time can not be bigger than current date time";
      return;
    } else if (endDateObj > currentDateObj) {
      processTimeErr.textContent =
        "End date and Time can not be bigger than current date time";
      return;
    } else if ((endDateObj - startDateObj) / (1000 * 60 * 60) > 24) {
      processTimeErr.textContent = "Duration can not be more than 24 hours";
      return;
    }

    let payLoad = {
      processTimeId: id,
      startTime: newStartTime,
      endTime: newEndTime,
    };
    let overlapPayload = {
      processId: process.processId,
      processTimeId: id,
      startTime: newStartTime,
      endTime: newEndTime,
    };
    api
      .hasOverlap(overlapPayload)
      .then((res) => {
        let isOverlapping = res.data.object;
        if (isOverlapping) {
          //display error message since the edited process time is overlapping with other times

          if (processTimeErr) {
            processTimeErr.textContent = "There is a time conflict.";
          } else {
            console.log("couldn't find error message");
          }
        } else {
          api
            .saveTimeEdit(payLoad)
            .then((res) => {
              console.log("submitted correctly");
              let newProcessTime = res.data.object;
              let newArr = processTimesState.map((time) =>
                time.processTimeId === newProcessTime.processTimeId
                  ? {
                      ...time,
                      startDate: getDate(newProcessTime.startTime),
                      startTime: formatTime(newProcessTime.startTime),
                      endDate: getDate(newProcessTime.endTime),
                      endTime: formatTime(newProcessTime.endTime),
                      duration: newProcessTime.duration,
                    }
                  : time
              );
              setProcessTimesState(newArr);
              processTimeErr.textContent = "";
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((e) => {
        console.log("couldn't check overlap", e);
      });
  }
  useEffect(() => {
    let interval;

    if (timerOn) {
      // console.log("prev start time: ", startTime);
      //   setStartTime((prevStartTime) => prevStartTime || Date.now());
      interval = setInterval(() => {
        // console.log("date: ", Date.now.toString() + " start time: ", startTime , " oldElapsedTime: ", oldElapsedTime);
        // console.warn("process here is : ", process);
        let lastStartTime = 0;
        if (
          process.allProcessTimes &&
          process.allProcessTimes[process.allProcessTimes.length - 1]
        ) {
          // console.log("creating new process", process);
          lastStartTime = new Date(
            process.allProcessTimes[
              process.allProcessTimes.length - 1
            ].startTime
          );
        }
        let currentDate = new Date();
        // console.log("current date: ", currentDate , "old End time: ", oldEndTime , "start time: ", startTime)
        setElapsedTime(currentDate - lastStartTime + startTime);
        sendParentElapsedTime(currentDate - lastStartTime);
      }, 1000); // Update every second for better performance
    } else {
      //   setElapsedTime(0);
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [timerOn, startTime]);

  //   useEffect(() => {
  //     if (form.allProcessTimes && form.allProcessTimes.length > 0) {
  //       console.log(form.allProcessTimes);
  //       let lastTimeIndex = form.allProcessTimes.length - 1;
  //       let newDuration =
  //         new Date(form.allProcessTimes[lastTimeIndex].endTime) -
  //         new Date(form.allProcessTimes[0].startTime);
  //       console.log("new duration is ", newDuration);
  //       setElapsedTime(newDuration);
  //     }
  //   }, []);
  const continueForm = () => {
    // log current time
    // TODO : maybe add the follwoing functions under the api .then , but there is a delay that should be investigated when this is implemented
    // setTimerOn(true);
    // setIsPaused(false);
    // setStartTime(Date.now());
    // swapCurrentRunning(process.processId , );
    // handleEndTime(process.processId, "" , false);
    // api.continueProcess(process.processId).then(() => {
    //   console.log("process continued");
    // });
    resumeFunc(process.processId);
  };
  // const pauseForm = () => {
  //   // log current time
  //   setIsPaused(true);
  //   setTimerOn(false);
  //   setOldElapsedTime(elapsedTime);
  //   pauseFunc(Date.now())
  //   handleCalculateDurations();
  //   // api
  //   //   .endProcess(process.processId, [
  //   //     {
  //   //       sectionFieldId: 1,
  //   //       value: "",
  //   //     },
  //   //   ])
  //   //   .then(() => {
  //   //     console.log("paused process");
  //   //     handleEndTime(process.processId, Date.now() , true);
  //   //   });
  // };
  const handleSubmit = (event) => {
    console.log(event.nativeEvent.submitter.name);
    let btnName = event.nativeEvent.submitter.name;
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      if (btnName === "Save" || btnName === "Speichern") {
        event.preventDefault();
        event.stopPropagation();
        handleSaveForm();
      } else if (
        btnName === "Save And New" ||
        btnName === "Speichern und Neu"
      ) {
        console.log("i am in save and new");
        event.preventDefault();
        event.stopPropagation();
        handleSaveAndNewForm();
      }
    }

    setValidated(true);
  };
  async function handleSaveForm() {
    if (
      process.processType.name === "Incoming Call" ||
      process.processType.name === "Outgoing Call" ||
      isAdmin
    ) {
      console.warn("Current state of ongoing call bool is: ", ongoingCallBool);
      // If not finalized, triggering end process with isFinalized set to true to signal that we are saving the process
      // ongoingCallBool = false means that this call is not on
      if (!process.isFinalized && !ongoingCallBool) {
        // Special function here form Paulo, we will not handle the resuming then ending anymore
        // but rather, we will need to check the isRunning flag and send it to Paulo
        // if (!isRunning) await resumeFuncPromised(process.processId);
        let payloadDetails = processDetails.filter(
          (detail) =>
            detail.value && detail.value !== null && detail.value !== undefined
        );

        try {
          const response = await api.endProcess(
            process.processId,
            true,
            payloadDetails,
            !isRunning
          ); // Then wait for endProcess
          showSuccessMessage();
          handleFetchProcesses();
          setopenRow(false);
          console.log("saved", response);
        } catch (error) {
          console.error("An error occurred during the process:", error);
          // Handle errors from either resumeFunc or api.endProcess
        }
      }

      // Else, just update the details
      else {
        let payloadDetails = processDetails.filter(
          (detail) =>
            detail.value && detail.value !== null && detail.value !== undefined
        );
        //resumeFunc(process.processId);
        api.updateProcessDetails(process.processId, payloadDetails).then(() => {
          console.log("saved data", process);
          showSuccessMessage();
          setopenRow(false);
        });
      }
    } else {
      // triggering end process with isFinalized set to true to signal that we are saving the process
      let payloadDetails = processDetails.filter(
        (detail) =>
          detail.value && detail.value !== null && detail.value !== undefined
      );
      api
        .endProcess(process.processId, true, payloadDetails)
        .then(() => {
          console.log("saved");
        })
        .then(() => {
          showSuccessMessage();
          handleFetchProcesses();
        });
      // pauseFunc(true);
    }
  }
  function canEdit() {
    if (
      process.processType.name === "Incoming Call" ||
      process.processType.name === "Outgoing Call"
    ) {
      return true;
    }
    return false;
  }
  function handleSaveAndNewForm() {
    // triggering end process with isFinalized set to true to signal that we are saving the process
    //TODO: add isfinalized attribute when backend finishes it
    let payloadDetails = processDetails.filter(
      (detail) =>
        detail.value && detail.value !== null && detail.value !== undefined
    );
    api.endProcess(process.processId, true, payloadDetails).then(() => {
      console.log("saved");
      api
        .insertProcess({
          serviceId: process.service.serviceId,
          formId: processForm.formId,
          processTypeName: "OFFLINE_ACTIVITY",
        })
        .then(() => {
          showSuccessMessage();
          handleFetchProcesses();
        });
    });

    // pauseFunc(true);
  }

  function parentStartServiceFromLink(serviceId, formId) {
    let processPayload = {
      serviceId: serviceId,
      formId: formId,
      processTypeName: "OFFLINE_ACTIVITY",
    };
    api
      .insertProcess(processPayload)
      .then(() => {
        console.log("initiated process");
        pauseForm();
      })
      .catch((error) => {
        console.error("could'nt start process");
      });
  }
  const pauseForm = () => {
    //triggering end process with isFinalized set to false to signal that we are pausing the process
    pauseFunc(processDetails);
    setProcessDataCache((prevState) => ({
      ...prevState,
      [process.processId]: {
        processDetailsCache: processDetails,
        parentSelectionValuesCache: parentSelectionValues,
      },
    }));
  };

  const resetTimer = () => {
    setTimerOn(false);
    setElapsedTime(0);
  };

  const formatDuration = (time) => {
    // Convert elapsed time in milliseconds to hours:minutes:seconds format
    let seconds = Math.floor(time / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);

    seconds = seconds % 60;
    minutes = minutes % 60;

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };

  // Pad the time values with leading zeros
  const pad = (timeValue) => {
    return timeValue.toString().padStart(2, "0");
  };
  const handleRowClick = () => {
    if (!openRow && formOptions?.length == 0) {
      // fetch service details to obtain form options from it for the first time accrording to the process type
      let serviceId = process.service.serviceId;
      let processType = process.processType.name;
      let serviceObject = null;
      setLoading(true);
      api.getServiceById(serviceId).then((res) => {
        setLoading(false);
        serviceObject = res.data.object;
        console.log("service is : ", serviceObject);
        if (processType == "Offline Activity") {
          setFormOptions(serviceObject.offlineForms);
        } else if (processType == "Incoming Call") {
          setFormOptions(serviceObject.ddiForms);
        } else if (processType == "Outgoing Call") {
          setFormOptions(serviceObject.callLineForms);
        }
      });
    }
    setopenRow(!openRow);
  };
  const [openRow, setopenRow] = useState(expandedProcess ? true : isRunning);
  const [openTimes, setOpenTimes] = useState(false);
  const [assignedFormId, setAssignedFormId] = useState(
    processForm?.formId ? processForm.formId : ""
  );
  const [changeFormModal, setChangeFormModal] = useState({
    show: false,
    id: "",
  });
  const [deleteProcessTimeModal, setDeleteProcessTimeModal] = useState({
    show: false,
    id: "",
  });
  const handleChangingAssignedForm = (e) => {
    console.log(e.target.name);
    setAssignedFormId(e.target.name);
    setChangeFormModal({ show: true, id: e.target.name });
    console.log("new state : ", assignedFormId);
  };
  const updateProcessAssignedForm = () => {
    api.editProcessForm(process.processId, changeFormModal.id).then(() => {
      setLoading(true);
      api.getAgentFormById(changeFormModal.id).then((res) => {
        setProcessForm(res.data.object);
        setLoading(false);
      });
    });
  };

  function transformDateToRequestFormat(currentDate) {
    // const year = currentDate.getFullYear();
    // const month = currentDate.getMonth() + 1; // January is 0
    // const day = currentDate.getDate();
    // const hours = currentDate.getHours();
    // const minutes = currentDate.getMinutes();
    // const seconds = currentDate.getSeconds();

    // const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
    //   .toString()
    //   .padStart(2, "0")} ${hours.toString().padStart(2, "0")}:${minutes
    //   .toString()
    //   .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    let formattedDate = "";
    let utcDate = currentDate.toISOString().split("T");
    let datePart = utcDate[0];
    let timePart = utcDate[1].substring(0, 8);
    formattedDate = datePart + " " + timePart;

    return formattedDate;
  }
  const handleAddProcessTime = () => {
    const currentDate = new Date();
    const formattedDate = transformDateToRequestFormat(currentDate);
    let newProcessTime = {
      processId: process.processId,
      startTime: formattedDate,
      endTime: formattedDate,
    };

    api.addProcessTime(newProcessTime).then((res) => {
      let responseDate = res.data.object;
      let formattedDate = {
        ...responseDate,
        startDate: getDate(responseDate.startTime),
        startTime: formatTime(responseDate.startTime),
        endDate: getDate(responseDate.endTime),
        endTime: formatTime(responseDate.endTime),
        duration: responseDate.duration,
      };
      setProcessTimesState([formattedDate, ...processTimesState]);
    });
  };
  const newEditime = (value) => {
    const parts = value.split(":");
    let hours = parts[0] || "00";
    let minutes = parts[1] || "00";
    let seconds = parts[2] || "00";

    // Ensure hours are always two digits
    hours = hours.padStart(2, "0");

    // Limit minutes and seconds to two digits
    minutes = minutes.slice(0, 2);
    seconds = seconds.slice(0, 2);

    // Check for valid values (0-23 for hours, 0-59 for minutes and seconds)
    if (
      parseInt(hours) >= 0 &&
      parseInt(hours) <= 23 &&
      parseInt(minutes) >= 0 &&
      parseInt(minutes) <= 59 &&
      parseInt(seconds) >= 0 &&
      parseInt(seconds) <= 59
    ) {
      return `${hours}:${minutes}:${seconds}`;
    } else {
      // Handle invalid input (e.g., revert to previous value or display an error)
      console.log("invalid time");
      return "";
    }
  };
  function editTime(formattedTime, stateDate) {
    // Split the formatted time string into parts
    // let newTime = formattedTime.substring(0,8)
    let newTime = newEditime(formattedTime);
    console.log("edit time ", newTime);
    console.log("type is", typeof newTime);
    console.log(stateDate);
    const [hours, minutes, seconds] = newTime.split(":");
    // Convert parts to numbers
    const parsedHours = parseInt(hours, 10);
    const parsedMinutes = parseInt(minutes, 10);
    const parsedSeconds = parseInt(seconds, 10);

    // Create a new Date object with the current date and parsed time
    const newDate = new Date(stateDate);
    console.log(newDate);
    newDate.setHours(parsedHours, parsedMinutes, parsedSeconds);
    // Return the Date object
    return newDate;
  }
  return (
    <>
      <YesNoModal
        propShow={changeFormModal.show}
        handleYes={updateProcessAssignedForm}
        handleShowModal={() => {
          setChangeFormModal({ ...changeFormModal, show: false });
          // resetForm();
        }}
      >
        Changing the form will clear all not saved fields. Do you want to
        continue?
      </YesNoModal>

      <tr className="tr-grid">
        {isLoading ? <Loading /> : ""}
        <td
          className={
            process?.allProcessTimes &&
            process.allProcessTimes.length > 0 &&
            process?.allProcessTimes?.[0]?.endTime
              ? !isRunning
                ? openRow
                  ? "opened-form-dark arrow-box"
                  : "opened-form arrow-box"
                : openRow
                ? "running-form-dark arrow-box"
                : "running-form arrow-box"
              : "running-form arrow-box"
          }
          onClick={processForm ? handleRowClick : () => {}}
          style={{ cursor: processForm ? "pointer" : "unset" }}
        >
          {processForm && (
            <IoIosArrowUp
              size={20}
              className={openRow ? "rotate-icon rotated" : "rotate-icon"}
            />
          )}
        </td>
        <td
          className={
            process?.allProcessTimes &&
            process.allProcessTimes.length > 0 &&
            process?.allProcessTimes?.[0]?.endTime
              ? determineFormStatus(isRunning, openRow)
              : "running-form"
          }
        >
          {process.processType
            ? process.processType.name == "Offline Activity"
              ? strings[pageTitle][language].OfflineAct.toUpperCase()
              : process.processType.name === "Incoming Call"
              ? strings[pageTitle][language].InCall.toUpperCase()
              : process.processType.name === "Incoming Call"
              ? strings[pageTitle][language].OutCall.toUpperCase()
              : ""
            : ""}
        </td>
        <td
          className={
            process?.allProcessTimes &&
            process.allProcessTimes.length > 0 &&
            process?.allProcessTimes?.[0]?.endTime
              ? determineFormStatus(isRunning, openRow)
              : "running-form"
          }
        >
          {process.service ? process.service.name : ""}
        </td>
        <td
          className={
            process?.allProcessTimes &&
            process.allProcessTimes.length > 0 &&
            process?.allProcessTimes?.[0]?.endTime
              ? determineFormStatus(isRunning, openRow)
              : "running-form"
          }
        >
          {processForm ? processForm.name : ""}
        </td>
        <td
          className={
            process?.allProcessTimes &&
            process.allProcessTimes.length > 0 &&
            process?.allProcessTimes?.[0]?.endTime
              ? determineFormStatus(isRunning, openRow)
              : "running-form"
          }
        >
          {process.phoneNumber ? process.phoneNumber : ""}
        </td>
        <td
          className={
            process?.allProcessTimes &&
            process.allProcessTimes.length > 0 &&
            process?.allProcessTimes?.[0]?.endTime
              ? determineFormStatus(isRunning, openRow)
              : "running-form"
          }
        >
          {" "}
        </td>
        <td
          className={
            process?.allProcessTimes &&
            process.allProcessTimes.length > 0 &&
            process?.allProcessTimes?.[0]?.endTime
              ? determineFormStatus(isRunning, openRow)
              : "running-form"
          }
        >
          {process.line ? process.line : ""}
        </td>
        <td
          className={
            process?.allProcessTimes &&
            process.allProcessTimes.length > 0 &&
            process?.allProcessTimes?.[0]?.endTime
              ? determineFormStatus(isRunning, openRow)
              : "running-form"
          }
        >
          {process.isBillable ? <ImCheckmark /> : ""}
        </td>
        <td
          className={
            process?.allProcessTimes &&
            process.allProcessTimes.length > 0 &&
            process?.allProcessTimes?.[0]?.endTime
              ? determineFormStatus(isRunning, openRow)
              : "running-form"
          }
        >
          {isAdmin
            ? getDate(process.allProcessTimes[0]?.startTime) + " "
            : "" +
              formatTime(
                process.allProcessTimes[0] &&
                  process.allProcessTimes[0]?.startTime
              ) +
              " - "}
          {process.allProcessTimes &&
          process.allProcessTimes[process.allProcessTimes.length - 1]?.endTime
            ? formatTime(
                process.allProcessTimes[process.allProcessTimes?.length - 1]
                  ?.endTime
              )
            : ""}
        </td>
        <td
          className={
            process?.allProcessTimes &&
            process.allProcessTimes.length > 0 &&
            process?.allProcessTimes?.[0]?.endTime
              ? determineFormStatus(isRunning, openRow)
              : "running-form"
          }
        >
          {/* <Stopwatch formStartTime={form.allProcessTimes && form.allProcessTimes[0].startTime} /> */}
          <div>
            <span>{formatDuration(elapsedTime)}</span>
            {/* <div>
      
              <button onClick={toggleTimer}>{timerOn ? "Stop" : "Start"}</button>
              <button onClick={resetTimer} disabled={timerOn}>
                Reset
              </button>
            </div> */}
          </div>
        </td>
        <td
          className={
            process?.allProcessTimes &&
            process.allProcessTimes.length > 0 &&
            process?.allProcessTimes?.[0]?.endTime
              ? determineFormStatus(isRunning, openRow)
              : "running-form"
          }
          style={{ color: "black", backgroundColor: "red" }}
        >
          {!process.isFinalized ? (
            <div className="d-flex gap-2 align-items-center justify-content-end pe-1 ">
              <div>
                <BsFillExclamationTriangleFill
                  size={"18"}
                  style={{ color: "#bd2130" }}
                />
              </div>
              {!isAdmin &&
              process.processType.name !== "Incoming Call" &&
              process.processType.name !== "Outgoing Call" ? (
                !timerOn && isPaused ? (
                  <div className="process-icon">
                    <LiaPlayCircleSolid
                      size={"25"}
                      onClick={continueForm}
                      className="process-icon"
                    />
                  </div>
                ) : (
                  <div className="process-icon">
                    <FaPauseCircle size={"20"} onClick={pauseForm} />
                  </div>
                )
              ) : (
                ""
              )}
              {(!isAdmin &&
                process.processType.name !== "Incoming Call" &&
                process.processType.name !== "Outgoing Call") ||
              true ||
              (isAdmin && isEditing) ? (
                <div className="process-icon">
                  <RiDeleteBin6Fill size={"22"} onClick={() => setShow(true)} />
                </div>
              ) : (
                ""
              )}
            </div>
          ) : isAdmin && isEditing ? (
            <div className="d-flex gap-2 align-items-center justify-content-end pe-5 ">
              <div className="process-icon">
                <RiDeleteBin6Fill size={"22"} onClick={() => setShow(true)} />
              </div>
            </div>
          ) : (
            ""
          )}
        </td>
        <td className={openRow ? "expanded-row-content" : "hide-row"}>
          <div style={{ backgroundColor: "var(--agent-secondary-color)" }}>
            <div className="d-flex flex-column ">
              <MyContext.Provider
                value={{
                  processDetails,
                  setProcessDetails,
                  parentSelectionValues,
                  setParentSelectionValues,
                }}
              >
                <FormRowContext.Provider
                  value={{
                    parentDisabled:
                      isPaused && (!isAdmin || !isEditing) && !canEdit(),
                    parentStartServiceFromLink,
                  }}
                >
                  <div className="service-details-grid">
                    <div
                      className="grid-item-title"
                      style={{ color: "var(--accent-color)" }}
                    >
                      <h6 style={{ color: "var( --accent-color)" }}>
                        {strings[pageTitle][language].AssignedForm}
                      </h6>
                    </div>
                    {!isAdmin ? (
                      <div className="grid-item" style={{ width: "100%" }}>
                        {processForm ? processForm.name : ""}
                      </div>
                    ) : (
                      <div className="grid-item" style={{ width: "100%" }}>
                        <Form>
                          {formOptions &&
                            formOptions.map((form) => {
                              return (
                                <Form.Check
                                  onChange={handleChangingAssignedForm}
                                  key={form.formId}
                                  inline
                                  label={form.formName}
                                  name={form.formId}
                                  type={"radio"}
                                  checked={assignedFormId == form.formId}
                                  id={`inline-radio-${form.formId}`}
                                  disabled={
                                    isPaused && (!isAdmin || !isEditing)
                                  }
                                />
                              );
                            })}
                        </Form>
                        {/* <Form.Check
                          inline
                          disabled
                          label="3 (disabled)"
                          type={"radio"}
                          id={`inline-${"radio"}-3`}
                        /> */}
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      borderBottom: "1px solid black",
                      marginBottom: "1.5em",
                    }}
                  ></div>
                  <Form
                    noValidate
                    validated={validated}
                    onSubmit={handleSubmit}
                  >
                    <div className="process-grid">
                      {processForm &&
                        processForm.sections
                          .sort((a, b) => {
                            if (a.rank !== b.rank) {
                              return a.rank - b.rank; // Ascending order for rank
                            }
                            const aDate = new Date(a.created);
                            const bDate = new Date(b.created);
                            return aDate - bDate;
                          })
                          .map((section) => {
                            return (
                              <RenderSection
                                section={section}
                                key={section.sectionId}
                                isPreview={false}
                              />
                            );
                          })}
                    </div>
                    {/* <Button type="submit" name = "Submit form">Submit form</Button> */}
                    {isRunning ||
                    !isPaused ||
                    (isAdmin && isEditing) ||
                    canEdit() ? (
                      <div className="d-flex justify-content-end">
                        {
                          <button
                            type="submit"
                            // name={strings[pageTitle][language].Save}
                            name="Save"
                            className="button-round"
                            style={{ alignSelf: "flex-end", margin: "1em" }}
                            // onClick={() => {
                            //   handleSaveForm();
                            // }}
                          >
                            {strings[pageTitle][language].Save}
                          </button>
                        }
                        {process.processType.name !== "Incoming Call" &&
                          process.processType.name !== "Outgoing Call" &&
                          !isAdmin && (
                            <button
                              type="submit"
                              name="Save And New"
                              className="button-round"
                              style={{ alignSelf: "flex-end", margin: "1em" }}
                              // onClick={() => handleSaveAndNewForm()}
                            >
                              {strings[pageTitle][language].SaveAndNew}
                            </button>
                          )}
                      </div>
                    ) : (
                      ""
                    )}
                  </Form>
                </FormRowContext.Provider>
              </MyContext.Provider>
            </div>
          </div>
          {!isRestricted && (
            <div className="process-times-container">
              <div
                className="times-btn"
                onClick={() => setOpenTimes(!openTimes)}
              >
                <IoIosArrowUp
                  size={20}
                  className={openTimes ? "times-icon rotated" : "times-icon"}
                />
              </div>
              {openTimes && (
                <div className="process-times">
                  {((isEditing && isAdmin) ||
                    (!isAdmin && !isRestricted && isPaused)) && (
                    <div className="add-time-btn">
                      <FaPlus size={20} onClick={handleAddProcessTime} />
                    </div>
                  )}
                  {processTimesState
                    .sort((a, b) => b.processTimeId - a.processTimeId)
                    .map((processTime) => {
                      return (
                        <div className="d-flex flex-column ">
                          <div
                            className="process-times__row"
                            key={processTime.processTimeId}
                          >
                            <Form.Control
                              disabled={
                                (isAdmin && !isEditing) ||
                                (!isAdmin && !isPaused)
                              }
                              name="name"
                              type="text"
                              value={processTime.startDate}
                              onChange={(e) =>
                                handleChangeProcessTime(
                                  e,
                                  processTime.processTimeId,
                                  "start",
                                  "date"
                                )
                              }
                              onBlur={(e) => {
                                if (
                                  (isAdmin && isEditing) ||
                                  (!isAdmin && isPaused)
                                ) {
                                  console.log("hello from form");
                                  console.log("state is ", processTimesState);
                                  handleSubmitDateTimeEdit(
                                    processTime.processTimeId,
                                    e,
                                    "start"
                                  );
                                }
                              }}
                            />
                            <Form.Control
                              disabled={
                                (isAdmin && !isEditing) ||
                                (!isAdmin && !isPaused)
                              }
                              name="name"
                              type="text"
                              value={processTime.startTime}
                              onChange={(e) =>
                                handleChangeProcessTime(
                                  e,
                                  processTime.processTimeId,
                                  "start",
                                  "time"
                                )
                              }
                              onBlur={(e) => {
                                if (
                                  (isAdmin && isEditing) ||
                                  (!isAdmin && isPaused)
                                ) {
                                  console.log("hello from form");
                                  console.log("state is ", processTimesState);
                                  handleSubmitDateTimeEdit(
                                    processTime.processTimeId,
                                    e,
                                    "start"
                                  );
                                }
                              }}
                            />
                            {"-"}
                            <Form.Control
                              disabled={
                                (isAdmin && !isEditing) ||
                                (!isAdmin && !isPaused)
                              }
                              name="name"
                              type="text"
                              value={processTime.endDate}
                              onChange={(e) =>
                                handleChangeProcessTime(
                                  e,
                                  processTime.processTimeId,
                                  "end",
                                  "date"
                                )
                              }
                              onBlur={(e) => {
                                if (
                                  (isAdmin && isEditing) ||
                                  (!isAdmin && isPaused)
                                ) {
                                  console.log("hello from form");
                                  console.log("state is ", processTimesState);
                                  handleSubmitDateTimeEdit(
                                    processTime.processTimeId,
                                    e,
                                    "end"
                                  );
                                }
                              }}
                            />
                            <Form.Control
                              disabled={
                                (isAdmin && !isEditing) ||
                                (!isAdmin && !isPaused)
                              }
                              name="name"
                              type="text"
                              value={processTime.endTime}
                              onChange={(e) =>
                                handleChangeProcessTime(
                                  e,
                                  processTime.processTimeId,
                                  "end",
                                  "time"
                                )
                              }
                              onBlur={(e) => {
                                if (
                                  (isAdmin && isEditing) ||
                                  (!isAdmin && isPaused)
                                ) {
                                  console.log("hello from form");
                                  console.log("state is ", processTimesState);
                                  handleSubmitDateTimeEdit(
                                    processTime.processTimeId,
                                    e,
                                    "time"
                                  );
                                }
                              }}
                            />
                            <p style={{ whiteSpace: "nowrap" }}>
                              {formatDuration(processTime.duration * 1000)}
                            </p>
                            {(processTimesState?.length > 1 &&
                              isAdmin &&
                              isEditing) ||
                              (!isAdmin && !isRestricted && isPaused && (
                                <div
                                  className="process-icon"
                                  style={{ color: "var(--accent-color)" }}
                                >
                                  <RiDeleteBin6Fill
                                    size={"15"}
                                    onClick={() =>
                                      setDeleteProcessTimeModal({
                                        show: true,
                                        id: processTime.processTimeId,
                                      })
                                    }
                                  />
                                </div>
                              ))}
                          </div>
                          <p
                            style={{ color: "red" }}
                            id={"processTime-" + processTime.processTimeId}
                            className="m-0 ps-2"
                          ></p>
                        </div>
                      );
                    })}
                  <YesNoModal
                    NoText={strings[pageTitle][language].DeleteMsgCancel}
                    YesText={strings[pageTitle][language].DeleteMsgDelete}
                    propShow={deleteProcessTimeModal.show}
                    handleYes={handleDeleteProcessTime}
                    handleShowModal={() => {
                      setDeleteProcessTimeModal({
                        ...deleteProcessTimeModal,
                        show: false,
                      });
                      // resetForm();
                    }}
                  >
                    {strings[pageTitle][language].DeleteProcessTimeHeader}
                  </YesNoModal>
                </div>
              )}
            </div>
          )}
        </td>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {strings[pageTitle][language].DeleteMsgHeader}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>{strings[pageTitle][language].DeleteMsgBody}</Modal.Body>
          <Modal.Footer>
            <Button variant="light" onClick={handleClose}>
              {strings[pageTitle][language].DeleteMsgCancel}
            </Button>
            <Button
              variant="danger"
              onClick={() => handleDeleteProcess(process.processId)}
            >
              {strings[pageTitle][language].DeleteMsgDelete}
            </Button>
          </Modal.Footer>
        </Modal>
      </tr>
    </>
  );
}

export default FormRowData;
